import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { Customer } from '@df/session/api/customer';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { LocalCustomerModel } from '../../../../customer/customer.model.decorator';
import { NAntavo } from '../../../../module/antavo/antavo.interface';
import { AntavoService } from '../../../../module/antavo/antavo.service';
import { NAccountMissionDetails } from './account-mission-details.component';

/**
 * Resolver to load specific Antavo challenge details for the mission details page
 */
export const accountMissionDetailsResolver: ResolveFn<NAntavo.IChallenge | undefined> = async route => {
    const antavoService = inject(AntavoService);
    const router = inject(Router);
    const customer = inject(Customer);
    const iCmsBlockResource = inject(ICmsBlockResource);
    const missionId = route.paramMap.get('id');

    const customerModel = (await customer.model.load()) as LocalCustomerModel;

    if (!customerModel?.loyaltyId || !missionId) {
        return undefined;
    }

    await iCmsBlockResource.retrieve({ bareUrl: NAccountMissionDetails.componentId }, undefined);

    try {
        const challengesResponse = await antavoService.getChallenges(customerModel.loyaltyId);
        const mission = challengesResponse?.payload?.find(challenge => challenge.id === missionId);
        if (!mission) {
            router.navigateByUrl('/account/my-missions');
        }
        return mission;
    } catch (error) {
        console.error('Failed to load challenge details:', error);
        return undefined;
    }
};
